module.exports = __webpack_public_path__ + "assets/img/headerBg.75651c2f.png";